import React from 'react';
import { ThumbnailImage, ThumbnailImageProps } from '../ThumbnailImage/ThumbnailImage';
import { Carousel } from '@jbhi-fi/lanyard-ui/components/Carousel';
import { useBreakpoint } from '@jbhi-fi/lanyard-ui/utils/useBreakpoint';
import { CarouselProps } from '@jbhi-fi/lanyard-ui/components/Carousel/Carousel';

export type ThumbnailImageCarouselProps = {
  thumbnails: Array<ThumbnailImageProps>;
  isStacked?: boolean;
  carouselProps?: Partial<CarouselProps>;
};

export const ThumbnailImageCarousel = ({
  thumbnails,
  isStacked = false,
  carouselProps = {},
}: ThumbnailImageCarouselProps) => {
  const isDesktop = useBreakpoint('md', 'up');
  const showStacked = isStacked && !isDesktop;

  const orderedThumbnails = showStacked
    ? thumbnails.filter((_, i) => i % 2 === 0).concat(thumbnails.filter((_, i) => i % 2 === 1))
    : thumbnails;

  return (
    <Carousel
      grid={showStacked ? { rows: 2, fill: 'row' } : undefined}
      slidesPerView="auto"
      showPagination={false}
      showArrows={isDesktop}
      spaceBetween={showStacked ? 16 : 0}
      slidesOffsetBefore={-8}
      slidesPerGroup={isDesktop ? 2 : 1}
      fullBleed={!isDesktop}
      arrowPosition="bottom"
      {...carouselProps}
    >
      {orderedThumbnails.map((thumbnail, i) => (
        <ThumbnailImage key={i} {...thumbnail} />
      ))}
    </Carousel>
  );
};
